module.exports = __webpack_public_path__ + "media/assets/faria_products/Partner Add Ons-4fb95c5eb19234957ca7d8f945f76e49311aeeedc0f8cf87ce4ce3d93100bff7.png";